<template>
  <div class="banner">
    <NrIcon
      :name="getIcon(getTypeIdentifier(type))"
      :class="`banner-icon-${getTypeIdentifier(type)}`"
    />
    <span
      data-cy="nr-banner-label"
      :class="`banner-label banner-label-${getTypeIdentifier(type)}`"
      >{{ type }}</span
    >
  </div>
</template>
check-square
<script>
import NrIcon from '../NrIcon'
export default {
  name: 'NrBanner',
  components: { NrIcon },
  props: {
    type: String
  },
  methods: {
    getTypeIdentifier(type) {
      return type.replace(/\s/, '').toLowerCase()
    },
    getIcon(icon) {
      switch (icon) {
        case 'overdue':
          return 'exclamation-triangle'
        case 'open':
          return 'folder-open'
        case 'closed':
          return 'check-square'
        case 'duesoon':
          return 'flag'
        case 'paused':
        default:
          return 'pause'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  width: 150px;
  .nr-icon.banner-icon-closed {
    transform: scale(2.2) translate(-3px, 3.3px);
    margin-top: 9px;
  }
  .nr-icon.banner-icon-paused {
    transform: scale(2.2) translate(-3px, 3.3px);
    margin-top: 9px;
    color: #424252;
  }
  .nr-icon.banner-icon-overdue {
    transform: scale(2.2) translate(-3px, 3.3px);
    margin-top: 9px;
    color: #e00000;
  }
  .nr-icon.banner-icon-open {
    transform: scale(2.2) translate(-3px, 3.3px);
    margin-top: 9px;
    margin-right: 1px;
    color: #007ac2;
  }
  .nr-icon.banner-icon-duesoon {
    transform: scale(2.2) translate(-3px, 3.3px);
    margin-top: 9px;
    color: #f8e71c;
  }
  &-label {
    color: white;
    position: relative;
    left: 7px;
    padding: 0px 4px;
    border-radius: 4px;
    font-size: 24px;
    line-height: 36px;
    display: inline-block;
    &-open {
      background: hsl(202, 100%, 38%);
    }
    &-closed {
      background: black;
    }
    &-overdue {
      background: #e00000;
    }
    &-paused {
      background: #424252;
    }
    &-duesoon {
      background: #f8e71c;
      color: black;
    }
  }
}
</style>
